import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from 'src/app/pages/subscription/services/subscription.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { TokenPack } from 'src/app/pages/shared/token-credit-modal/model/token-credit.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-world-credits-modal-purchase',
    templateUrl: './world-credits-modal-purchase.component.html',
    styleUrls: ['./world-credits-modal-purchase.component.scss'],
    standalone: false
})
export class WorldCreditsModalPurchaseComponent implements OnInit {
  userId: number | string | any;
  tokenPacks: TokenPack[] = [];
  isLoading: boolean = false;
  currentUserSubscription: Subscription;

  constructor(public activeModal: NgbActiveModal,
    private subscriptionService: SubscriptionService,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUserSubscription = this.currentUserService.currentUser.subscribe((res) => {
      if (res && res.id) {
        this.userId = res.id;
        this.getProducts();
      }
    
          this.cdr.detectChanges();});
  }

  getProducts() {
    this.isLoading = true;
    this.subscriptionService.getStripeProducts().subscribe({
      next: (res: { token_packs: TokenPack[] }) => {
        this.tokenPacks = res.token_packs.filter((product: TokenPack) => product.pack_type === 'wcredit');
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
      
          this.cdr.detectChanges();}
    });
  }

  buyProduct(tokenPackId: number) {
    this.subscriptionService.createTokenPackCheckoutSession(this.userId, tokenPackId).subscribe((res) => {
      if (res && res.checkout_url) {
        window.location.href = res.checkout_url;
      }
    
          this.cdr.detectChanges();});
  }

  closeModal() {
    this.activeModal.close();
  }

  purchaseWorldCredit() {
    // Navigate or trigger purchase flow
  }
}
